<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fa fa-sellsy text-primary"></i> Promote Student</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-12">
          <label class="form-label fw-bold">From :</label>
          <div class="row g-2">
                <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.FromClsId)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.FromClsId = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup>
                :</label>
              <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.FromSecId" @change="listData()">
                <option selected=""></option>
                <option v-for="(item, index) in secList" :key="index" :value="item._id">
                  {{ item.Name }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Student
                :</label>
              <select v-model="Obj.StudentID" class="form-select form-select-sm rounded cursor-pointer" role="button">
                <option selected=""></option>
                <option v-for="(item, index) in
                  List1" :key="index" :value="item._id"> {{ item.firstName }} {{ item.lastName }} </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <label class="form-label fw-bold">To :</label>
          <div class="row g-2">
              <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.ToClsId)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.ToClsId = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup>
                :</label>
              <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.ToSecId">
                <option selected=""></option>
                <option v-for="(item, index) in secList" :key="index" :value="item._id">
                  {{ item.Name }}
                </option>
              </select>
            </div>
            <div class="col-md-3 text-end mt-5">
              <button class="btn btn-sm btn-darknavy me-1" @click="save()">
                <i class="fas fa-graduation-cap"></i> Promote
              </button>
               <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fas fa-times-circle  me-1"></i> Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
              <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
            </ul>
      <div class="row">
        <div class="col-md-9 table-responsive mt-2" style="margin-top:5px;">
           <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
 <DelPopup v-if="delObj._id" :name="delObj.StudentName" @delRecord="delRecord" @closeModal="delObj = {}"> </DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList} = schoolStore();
  const  Obj = ref( {FromClsId: "", FromSecId: "", StudentID: "", ToClsId: "", ToSecId: "", })
  const List1= ref([])
    const Students= ref([])
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
    const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'From Class', key: 'FromCls' },
  { label: 'Name', key: 'StudentName' },
  { label: 'To Class', key: 'ToCls' }
]);
const handleEdit = async(row) => {
Obj.value = {...row};
await api .get(`/students/clssection/${Obj.value.ToClsId}/${Obj.value.ToSecId}/`)
    .then(async(res) => { 
      List1.value = res.data 
      const res1 = await api.get(`/students/${ Obj.value.StudentID}`);
      Obj.value.StudentID =res1.data.student._id
    });     
}
const handleDelete = async(row) => {
  delObj.value = { ...row };
}
const rows=ref([])
const loadStudents= async() => {
  const res = await api.get(`/students/search`);
  Students.value = res.data;
}
const listData= async()=> {
await api.get(`/students/clssection/${Obj.value.FromClsId}/${Obj.value.FromSecId}/`)
      .then((res) => { List1.value = res.data });
  
}
const save = async () => {
  const fields = {
    FromClass: { value: Obj.value.FromClsId, validators: [isRequired] },
    FromSection: { value: Obj.value.FromSecId, validators: [isRequired] },
    ToClass: { value: Obj.value.ToClsId, validators: [isRequired] },
    ToSection: { value: Obj.value.ToSecId, validators: [isRequired] },
  };

  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length !== 0) return;
  if (!Obj.value.StudentID) {
    const res = await api.get( `/students/clssection/${Obj.value.FromClsId}/${Obj.value.FromSecId}` );
    const allStudents = res.data;
    for (const stu of allStudents) {
      const payload = {
        FromClsId: Obj.value.FromClsId,
        FromSecId: Obj.value.FromSecId,
        StudentID: stu._id,
        ToClsId: Obj.value.ToClsId,
        ToSecId: Obj.value.ToSecId,
      };
      await api.post("/promote/add", payload).catch(() => {});
    }
    msgObj.value = { msg: "Class promoted successfully!", role: "success", show: true };
    loadData();
    reset();
    return;
  }
  const { url, method, msg } = curdStatus(Obj.value);
  await api[method](`/promote${url}`, Obj.value)
    .then(() => {
      loadData();
      reset();
      msgObj.value = { msg: `Promote ${msg} Successfuly`, role: "success", show: true };
    })
    .catch((error) => console.log(error));
};

const reset= async()=> {
  Obj.value = { FromClsId: "", FromSecId: "", StudentID: "", ToClsId: "", ToSecId: "", };
  msgObj.value = { msg: "", role: "", show: false, };
  errors.value={}
}
 const progress = ref(0)
const loadData= async()=> {
  let direction = 1
  let progressInterval = setInterval(() => {
    progress.value += direction
    if (progress.value >= 100) {
      progress.value = 0 
    }
  }, 100)
  await api.get('/promote/all').then(async (response) => {
    const studentNames = await Promise.all(response.data.map(async (item) => {
    const res = await api.get(`/students/${item.StudentID}`);
    return `${res.data?.student?.firstName} ${res.data?.student?.lastName}`|| '';
    }));
    rows.value = response.data.map((item, i) => ({
    ...item,
    Sno: i + 1,
    FromCls: `${clsList.value.find(c => c._id === item.FromClsId)?.name || ''}${clsList.value.find(c => c._id === item.FromClsId)?.name ? (secList.value.find(s => s._id === item.FromSecId)?.Name ? ' (' + secList.value.find(s => s._id === item.FromSecId)?.Name + ')' : '') : ''}`,
    ToCls: `${clsList.value.find(c => c._id === item.ToClsId)?.name || ''}${clsList.value.find(c => c._id === item.ToClsId)?.name ? (secList.value.find(s => s._id === item.ToSecId)?.Name ? ' (' + secList.value.find(s => s._id === item.ToSecId)?.Name + ')' : '') : ''}`,
    StudentName: studentNames[i],
    }));
    progress.value = 0
    clearInterval(progressInterval)
    });
}
const delRecord = async()=> {
  await api.delete(`/promote/${delObj.value._id}`)
    .then(() => {
      loadData();
      delObj.value = {};
      msgObj.value = { msg: "Promote Deleted Successfuly.", role: "danger", show: true, };
    });
}
onMounted(async() => { await loadStudents(); await loadData(); })
</script>